import HB1416SessionLog from './HB1416SessionLog.component';

export default HB1416SessionLog;
